/* eslint-disable eqeqeq */
import React,{useState,useCallback,useEffect} from 'react';
import {findDOMNode} from 'react-dom';
import {ListView,InputItem,Button,Flex} from 'antd-mobile';
import {connect} from 'dva';
import './supplier.css';

const dataSource = new ListView.DataSource({
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
/********************************************************** */
let lv;
let lvTemp=0;
let AAA301= 0;
let scorllTop=0;
let rData=[];
let hasMore = true;
/***************************************************** */
function initLet()
{
  AAA301= 0;
  rData=[];
  hasMore = true;
}

let renderHeader =()=>{
    return (<span>供货商信息</span>);
}

//间距
function renderSeparator(sectionID,rowID){
    return (
      <div
        key={`${sectionID}-${rowID}`}
        style={{
          backgroundColor: '#F5F5F9',
          height: 2,
          borderTop: '1px solid #ECECED',
          borderBottom: '1px solid #ECECED',
        }}
      />
    );
  }
  function onScroll(scroll){
    
    lvTemp=scroll.target.scrollTop;
    console.log(lvTemp);
     
  }
function Supplier(props)
{
    let [LVdataSource,setDataSource] = useState(dataSource);
    let [AAA004,setAAA004] =useState();
    let [height,setHeight] = useState(document.documentElement.clientHeight);

    
    
    useEffect(()=>{

       if (AAA301==0)
       {
        initLet();
        genData();
        setHeight(height - findDOMNode(lv).offsetTop);
        
       }else{
        setDataSource(dataSource.cloneWithRows(rData));
        setTimeout(() => lv.scrollTo(0, scorllTop), 800);
        
       }
       return ()=>{
        scorllTop=lvTemp;
       }
       
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[0]);

    
    let genData = useCallback(()=>{
      console.log(AAA004);
        props.dispatch({type:"index/aa03queryGHS",payload:{
          AAA201:localStorage.getItem("AAA201"),
          AAA301,
          AAA004
      }}).then((res)=>{

          if(res.length>0)
          {
              hasMore = true;
          }else{
              hasMore = false;
          }
          rData.push(...res);
          setDataSource(dataSource.cloneWithRows(rData));
          AAA301 = AAA301+10
      });
    },[props,AAA004]);


    let onEndReached = useCallback(()=>{
        if (props.isLoading ) {
          return;
        }
        if(!hasMore)
        {
            return;
        }
          genData();

      },[props.isLoading,genData]);

      let renderFooter = useCallback(()=>{
        return (
          <div style={{ padding: 30, textAlign: 'center' }}>{ hasMore?(props.isLoading ? '请稍等正在加载...' : '加载完成'):'亲掉头吧...没有数据了'}</div>
        );
       },[props.isLoading]);

     let handelSearch = useCallback(()=>{
         initLet();
         genData();
     },[genData]);
   
     let qhHandle =(rowData)=>{
         console.log(rowData);
      props.dispatch({type:"index/qhdls",payload:{
       AAA001 : rowData.AAA001,
       AAA004 : rowData.AAA004,
       AAA201 : rowData.AAA201,
       AAC002 : rowData.AAC002,
       AAC003 : rowData.AAC003,
       route:"/home"
      }});

    }
         //行显示
  let renderRow=(rowData, sectionID, rowID)=>
  {
    let spancss;
    if (rowData.AAA001 == localStorage.getItem("AAA001"))
    {
      spancss = {fontSize: '15px', color: '#ff0900'};
    }else{
      spancss = {fontSize: '15px', color: '#000000'};
    }
    return (
      <div key={rowID} style={{ padding: '0 15px' }}>
        <div style={{lineHeight: '30px',color: '#888',fontSize: 15,borderBottom: '1px solid #0051ff',}}>
        <span style={spancss}> { `名称: ${rowData.AAA004}` } </span>
        </div>

          <Button type="primary" onClick={()=>qhHandle(rowData)} inline size="small" style={{ marginRight: '1px' }}>切换</Button>
      </div>
    );
  }
    return (<div>
        <Flex className="gridHead" alignContent ="between">
          <InputItem type="text" value={AAA004} onChange={(value)=>setAAA004(value)} placeholder="请输入供货商名称..." ></InputItem>
          <Button type="primary" inline onClick={handelSearch}  >搜索</Button>
        </Flex >
        
        <ListView
          key={0}
          ref={el => lv = el}
          onScroll={onScroll}
          dataSource={LVdataSource}
          renderHeader={renderHeader}
          renderFooter={renderFooter}
          renderRow={renderRow}
          renderSeparator={renderSeparator}
          useBodyScroll={false}
          style={ {height: height,border: '1px solid #ddd',margin: '5px 0',}}
          onEndReached={onEndReached}
          pageSize={5}
        />
      </div>);
}

export default connect(state=>{
    return {
        ...state.index,
        isLoading: state.loading.global
    }
})(Supplier);